import { createFileRoute, Outlet } from "@tanstack/react-router";

function CompleteLayout() {
    return <Outlet />;
}

export const Route = createFileRoute("/forms/$formId/diary/$diaryId/tracker/$trackerId/entry/$entryId/complete")({
    component: CompleteLayout,
});
